import React, {useState, useEffect} from "react";
import "./Portal.css";
import {useAuth} from "../../AuthContext";
import { Navigate } from 'react-router-dom';
// import {distributionItems} from "../../data/distributionItems";
import {useTranslation} from "react-i18next";
import upload from '../../img/arrow.png';
import {PaymentWidget} from "./PaymentWidget";
import CustomDropdown from "./CustomDropdown";
import { ReactComponent as Refresh } from '../../icons/refresh.svg';

import {Scrollbar} from "react-scrollbars-custom";

const apiItems = [
    {title: 'WhatsApp', id: 0, priceField: 'price_wa'},
    {title: 'Telegram', id: 1, priceField: 'price_telegram'},
    {title: 'IMO', id: 2, priceField: 'price_imo'},
    {title: 'Viber', id: 3, priceField: 'price_viber'}
]
export function Portal() {
    const [currentPriceItem, setCurrentPriceItem] = React.useState(null);
    const [mode, setMode] = useState('manual');
    const [csvFile, setCsvFile] = useState(null);
    const [phones, setPhones] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const [campaigns, setCampaigns] = useState([]);
    const [selectedCampaignId, setSelectedCampaignId] = useState('');
    const [statuses, setStatuses] = useState([]);

    const [isLoading, setLoading] = useState(false);

    const [reloading, setReloading] = useState(false);


    const { accessToken, user, loading, fetchWithAuth } = useAuth();
    const { t } = useTranslation();
    // Получить список рассылок
    const fetchCampaigns = async () => {
        try {
            const res = await fetchWithAuth('/api/web/campaigns');
            const data = await res.json();
            if (data.success) setCampaigns(data.campaigns);
        } catch (err) {
            console.error('Error loading campaigns', err);
        }
    };
    useEffect(() => {
        const load = async () => {
            await fetchCampaigns();
        };
        load();
    }, []);

    useEffect(() => {
        if (user && !currentPriceItem) {
            const firstEnabled = apiItems.find(item => user[item.title.toLowerCase()]);
            if (firstEnabled) {
                setCurrentPriceItem(firstEnabled);
            }
        }
    }, [user, currentPriceItem]);

    if (loading) return <div>Loading...</div>;

    if (!accessToken) return <Navigate to="/login" replace />;

    if (!user) return <div>Loading user data...</div>;
    if (!currentPriceItem) return <div>Loading channels...</div>;
    const fetchStatuses = async (campaignId) => {
        try {
            const res = await fetchWithAuth(`/api/web/campaign/${campaignId}`);
            const data = await res.json();
            if (data.success) setStatuses(data.data);
        } catch (err) {
            console.error('Error while fetching messages:', err);
        }
    };


    const parsePhones = async () => {
        if (mode === 'manual') {
            return phones
                .split(/[\n,;]/)
                .map(p => p.replace(/\s+/g, '').trim())
                .filter(p => /^\+?\d+$/.test(p));
        }

        if (mode === 'csv' && csvFile) {
            const text = await csvFile.text();
            return text
                .split(/\r?\n/)
                .map(p => p.replace(/\s+/g, '').trim())
                .filter(p => /^\+?\d+$/.test(p));
        }
        return [];
    };

    const handleMessageSubmit = async () => {
        setError(null);
        setSuccess(null);
        const phoneList = await parsePhones();
        if (!message || phoneList.length === 0) {
            setError('Please provide a message and at least one phone number');
            return;
        }

        setLoading(true);

        try {
            const res = await fetchWithAuth('/api/web/campaigns/send', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    phones: phoneList,
                    message,
                    name: 'Campaign ' + Date.now(),
                    type: currentPriceItem?.title.toLowerCase(),
                })
            });

            if (!res) {
                setError('No response from server');
                return;
            }
            const data = await res.json().catch(() => ({}));
            if (res.ok) {
                setSuccess('Messages sent successfully!');
                setMessage('');
                setPhones('');
                setCsvFile(null);
                await fetchCampaigns(); // 🔄 обновить список рассылок
                window.dispatchEvent(new Event('force-balance-reload'));
            } else {
                setError(data.error || 'Failed to send SMS');
            }
        } catch (err) {
            console.error(err);
            setError('An error occurred while sending the SMS');
        } finally {
            setLoading(false);
        }
    };

    const reloadMessages = async () => {
        if (reloading) return;
        setReloading(true);
        await Promise.all([
            fetchStatuses(selectedCampaignId),
            new Promise((res) => setTimeout(res, 500))
        ]);
        setReloading(false);
    }
    const selectedCampaign = campaigns?.find(c => c.id === Number(selectedCampaignId));

    return (
        <div className="portalPage">
            <div className="sendContainer">
                <div className={'portalHeader'}>Create campaign</div>
                <div className={'sendItems'}>
                    {apiItems.map((item, index) => {
                        // const isDisabled = item.title !== 'WhatsApp'; // например, item.disabled === true
                        const isDisabled = !user[item.title.toLowerCase()]
                        const className = currentPriceItem?.id === item.id
                            ? 'selectedSendItem'
                            : isDisabled ? 'sendItem disabledSendItem' : 'sendItem';

                        return (
                        <div key={index} className={className} onClick={() => {setCurrentPriceItem(item)}}>{item.title}</div>
                    )})}
                </div>
                <div className="modeItems">
                    <div className={mode === 'manual' ? 'selectedSendItem' : 'sendItem'} onClick={() => setMode('manual')}>Enter numbers manually</div>
                    <div className={mode === 'csv' ? 'selectedSendItem' : 'sendItem'} onClick={() => setMode('csv')}>Upload CSV</div>
                </div>
                {mode === 'manual' ? (
                    <div className="phoneField">
                        <div className="labelP">
                            Phone list
                        </div>
                        <div className="blockGeneratorContentTextareaBlock">
                                <textarea
                                    className="blockGeneratorContentTextareaBlockTextarea"
                                    placeholder="Enter numbers separated by commas or line breaks (digits only)"
                                    value={phones}
                                    onChange={(e) => setPhones(e.target.value)}
                                    disabled={isLoading}
                                />
                            <div style={{ fontSize: '0.9em', marginTop: 5, whiteSpace: 'normal', wordWrap: 'breakWord', width: '100%', color: '#BABABA' }}>
                                Example: <code style={{ backgroundColor: 'transparent', color: '#BABABA' }}>1234567890, 9876543210, 5556667777</code>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="phoneField">
                        <label className="labelP">
                            Phone list
                        </label>
                        <label className="customFileUpload">
                            <img alt='upload' className="imageU" src={upload} />
                            <div className="fileName">
                                {csvFile ? csvFile.name : 'Select file'}
                            </div>
                            <div className="fileFormat">
                                CSV format
                            </div>
                            <input
                                type="file"
                                accept=".csv"
                                onChange={(e) => {
                                    if (e.target.files.length > 0) {
                                        setCsvFile(e.target.files[0]);
                                    }
                                }}
                                disabled={isLoading}
                            />
                        </label>
                    </div>
                )}
                <div className={'messageContainer'}>
                    <label className="labelP">
                        Message text
                    </label>
                    <textarea
                        className="blockGeneratorContentTextareaBlockTextarea"
                        placeholder="Message text"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        disabled={isLoading}
                    />
                </div>
                <div className="priceCentered">Cost per message: ${+user[apiItems[currentPriceItem.id].priceField]}</div>
                <button onClick={handleMessageSubmit} className="startCampaignButton" disabled={isLoading}>
                    <div className="buttonMode">{isLoading ? 'Sending' : 'Create campaign'}</div>
                </button>
                {error && <div className="loginError" style={{ color: '#268DFF' }}>{error}</div>}
                {success && <div className="loginError" style={{ color: '#268DFF' }}>{success}</div>}
                <div>
                <label className="labelP">
                    Created campaigns:
                </label>
                    <CustomDropdown
                        value={selectedCampaignId}
                        onChange={newBlockId => {
                            setSelectedCampaignId(newBlockId);
                            if (newBlockId) fetchStatuses(newBlockId);
                            else setStatuses([]);
                        }}
                        options={[
                            { label: '— Select campaign —', value: '' },
                            ...campaigns.map(c => ({
                                label: `${c.name} • ${c.channel} • ${new Date(c.created_at).toLocaleDateString()}`,
                                value: c.id
                            }))
                        ]}
                        fullWidth
                    />
                </div>
                {selectedCampaign && (
                    <div>
                        <label className="labelP">Message text:</label>
                        <div className="messageText">{selectedCampaign.message}</div>
                    </div>
                )}
                    {statuses.length > 0 && (
                        <div>
                            <div className="messageList">
                                <label className="labelP">
                                    Message list:
                                </label>
                                <div className={'reloadBalanceContainer'}>
                                <div
                                    onClick={reloadMessages}
                                    className={reloading ? 'reloadBalanceSpin' : 'reloadBalance'}
                                >
                                    <Refresh />
                                </div>
                                </div>
                            </div>

                            <Scrollbar
                                style={{width: '100%', height: '200px', overflowX: 'auto', marginTop: '16px'}}
                                thumbYProps={{style: {background: '#268DFF',},}}
                                thumbXProps={{style: {background: '#268DFF',},}}
                            >
                                <table
                                    className="blockAllLinksTable"
                                >
                                    <thead>
                                    <tr>
                                        <th style={{ width: '100px'}} className="blockAllLinksTableHeadRowElement">#</th>
                                        <th className="blockAllLinksTableHeadRowElement">Phone number</th>
                                        <th className="blockAllLinksTableHeadRowElement">Status</th>
                                        <th className="blockAllLinksTableHeadRowElement">Price</th>
                                        <th className="blockAllLinksTableHeadRowElement">Created</th>
                                        <th className="blockAllLinksTableHeadRowElement">Updated</th>
                                        <th className="blockAllLinksTableHeadRowElement">Field 1</th>
                                        <th className="blockAllLinksTableHeadRowElement">Text</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {statuses.map((s) => (
                                        <tr key={s.id}>
                                            <td className="blockAllLinksTableDRowElement">{s.id}</td>
                                            <td className="blockAllLinksTableDRowElement">{s.dst_addr}</td>
                                            <td className="blockAllLinksTableDRowElement">{s.status}</td>
                                            <td className="blockAllLinksTableDRowElement">${s.price}</td>
                                            <td className="blockAllLinksTableDRowElement">{new Date(s.created_at).toLocaleString()}</td>
                                            <td className="blockAllLinksTableDRowElement">{new Date(s.status_updated_at).toLocaleString()}</td>
                                            <td className="blockAllLinksTableDRowElement">{s.field_1}</td>
                                            <td className="blockAllLinksTableDRowElement" title={s.text}>{s.text ? `${s.text.slice(0, 3)}...` : ''}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </Scrollbar>
                        </div>
                    )}
                <PaymentWidget />
            </div>
        </div>
    );
}
